import * as React from 'react';
import { ReadingPaneBehaviorContext } from '../context-providers/ReadingPaneBehaviorContext';

export const useTriageActionBehavior = () => {
    const triageActionBehavior = React.useContext(ReadingPaneBehaviorContext)?.triageActionBehavior;
    return triageActionBehavior;
};
